
import jsPDF from 'jspdf';
import { PDF_STYLES } from './pdfStyles';

export const addLogoAndCompanyInfo = async (pdf: jsPDF, yPosition: number): Promise<number> => {
  const { margin, rightMargin, logo, fonts } = PDF_STYLES;
  const pageWidth = pdf.internal.pageSize.width;
  
  // Load and add the logo
  try {
    const logoImg = new Image();
    logoImg.src = '/lovable-uploads/9d714595-5d4a-46b2-a38b-ab44cd6eb7e6.png';
    
    await new Promise((resolve, reject) => {
      logoImg.onload = resolve;
      logoImg.onerror = reject;
    });
    
    // Add logo on the left side
    pdf.addImage(logoImg, 'PNG', margin, yPosition, logo.width, logo.height);
  } catch (error) {
    console.warn('Could not load logo for PDF');
  }
  
  // Company information on the right side (right-aligned)
  pdf.setFontSize(fonts.subtitle);
  pdf.setFont(undefined, 'bold');
  pdf.text("Author's Tranquility Press", pageWidth - rightMargin, yPosition + 5, { align: 'right' });
  
  pdf.setFontSize(fonts.small);
  pdf.setFont(undefined, 'normal');
  pdf.text('531 Roselane Street NW Suite 400-175', pageWidth - rightMargin, yPosition + 10, { align: 'right' });
  pdf.text('Marietta, GA 30060', pageWidth - rightMargin, yPosition + 14, { align: 'right' });
  pdf.text('support@authorstranquilitypress.com', pageWidth - rightMargin, yPosition + 18, { align: 'right' });
  pdf.text('https://authorstranquilitypress.com', pageWidth - rightMargin, yPosition + 22, { align: 'right' });
  pdf.text('Hotline 24/7: +1 (866) 411 8655', pageWidth - rightMargin, yPosition + 26, { align: 'right' });
  
  return yPosition + 35;
};

export const addReportHeader = (pdf: jsPDF, quarter: number, year: number, authorName: string, yPosition: number): number => {
  const { margin, fonts } = PDF_STYLES;
  
  // Main Title
  pdf.setFontSize(fonts.title);
  pdf.setFont(undefined, 'bold');
  pdf.text(`Q${quarter} ${year} Quarterly Royalty Report`, margin, yPosition);
  yPosition += 12;
  
  // Author Name
  pdf.setFontSize(fonts.normal);
  pdf.setFont(undefined, 'normal');
  pdf.text(`Report for ${authorName}`, margin, yPosition);
  
  return yPosition + 18;
};
